// extracted by mini-css-extract-plugin
module.exports = {"approversPanel":"checkRequest_approversPanel__j9Rde","computations":"checkRequest_computations__iYZcz"};